"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
console.debug('INFO SubjectValidatonPlugin.ts loaded');
var SubjectValidationPlugin = /** @class */ (function (_super) {
    __extends(SubjectValidationPlugin, _super);
    function SubjectValidationPlugin(field) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        return _this;
    }
    SubjectValidationPlugin.prototype.runCustomValidation = function () {
        if (this._isDefaultSubject()) {
            this.field.setCustomValidity('Please select a valid option.');
            return false;
        }
        this.field.setCustomValidity('');
        return true;
    };
    SubjectValidationPlugin.prototype._isDefaultSubject = function () {
        if ('selectedIndex' in this.field) {
            var pickedSubject = this.field.options[this.field.selectedIndex].innerHTML;
            var defaultSubject = this.field.parentElement.dataset.contactformDefaultsubject;
            return pickedSubject === defaultSubject;
        }
        return false;
    };
    SubjectValidationPlugin.prototype.isValid = function () {
        return this.runCustomValidation();
    };
    SubjectValidationPlugin.prototype._getMessageAttribute = function () {
        return 'data-subject-error-message';
    };
    SubjectValidationPlugin.prototype._getDefaultMessage = function () {
        return 'Please select another option.';
    };
    return SubjectValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = SubjectValidationPlugin;
